import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Shield, LogOut, Calendar, BookCheck } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { ResponsiveShell } from "@/components/ResponsiveShell";

export default function PengasuhLayout() {
  const { user, logout } = useAuth();
  return (
    <ResponsiveShell title="Penilaian Serdik" subtitle="Panel Pengasuh" widthClass="w-60" content={<Outlet />}>
        <div className="p-5 border-b border-navy-800">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-sm bg-brass-500 flex items-center justify-center">
              <Shield className="w-5 h-5 text-navy-900" />
            </div>
            <div>
              <div className="font-heading font-bold text-xs uppercase tracking-widest">Penilaian Serdik</div>
              <div className="text-[10px] text-brass-400 uppercase tracking-wider mt-0.5">Panel Pengasuh</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 p-2 space-y-0.5">
          <NavLink to="/pengasuh" end className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-sm text-sm transition-colors ${isActive ? "bg-brass-500 text-navy-900 font-semibold" : "text-white/70 hover:bg-navy-800 hover:text-white"}`}>
            <Calendar className="w-4 h-4" /> Jadwal Saya
          </NavLink>
        </nav>
        <div className="p-3 border-t border-navy-800">
          <div className="text-[10px] text-white/40 uppercase mb-1">Login sebagai</div>
          <div className="text-sm font-semibold mb-2">{user?.nama}</div>
          <button onClick={logout} data-testid="logout-btn" className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-navy-800 hover:bg-red-900 text-white/80 hover:text-white text-sm rounded-sm transition-colors">
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
    </ResponsiveShell>
  );
}
